






























import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import gtAdd from "./add.vue";
const attr = namespace("attribute");
@Component({
  components: { gtAdd }
})
export default class search extends Vue {
  input1: string = "";
  @attr.State params;
  @attr.State PageInput;
  @attr.Mutation setPageInput;
  @attr.Action getAttr;

  isDefaultOrg = true;
  created() {
    this.params.attrName = "";
  }
  mounted() {
    this.isDefaultOrg = localStorage.getItem("org") === "default";
  }
  async handleSearch(): Promise<void> {
    this.params.attrName = this.input1;
    this.setPageInput({
      ...this.PageInput,
      pageNum: 1
    });
    this.getAttr();
  }
  handleAdd() {
    const $add: any = this.$refs.$add;
    $add.dialogVisible = true;
  }
}
